exports.config = {
    cryptoSecret:"&F0J@NcRfUjXnZr4u7x!A%D*G-KaPdSg",
    WPNAREQUEST:"sO4nl&W5sVTpBOQ#Wo07bJGMdJTZ&isi$HTe#j3x",
    W2ADOMAIN:"https://api.staging.website2.app/"
};